import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import NotFound from '../not-found/NotFound';
import Loading from '../../components/Loading';
import { getProjectFromId } from '../projects-reducer';
import { hasWindow } from '../../utils/index';
import { trackPageView } from '../../support-and-tracking/analytics-actions';
import withRouter from '../../components/hooks/withRouter';
import { useParams } from 'react-router-dom';
import { ProjectEmbeddedComponent } from './ProjectEmbeddedComponent';
import { fetchProjectCard, fetchProjectTransactionAggregates } from '../project-actions';

function sendSize() {
    const app = document.querySelector('body');

    parent.postMessage({ height: app.offsetHeight, width: app.offsetWidth }, '*');
}

const ProjectEmbeded = () => {
    const params = useParams();
    const projectId = parseInt(params.projectId, 10);
    const isFetching = useSelector((state) => state.projects.isFetchingCards);
    const project = useSelector((state) => getProjectFromId(state, projectId));

    useEffect(() => {
        if (hasWindow()) {
            window.addEventListener('DOMContentLoaded', sendSize);
            window.addEventListener('resize', sendSize);
        }
        trackPageView({ urlAsEvent: 'project-embed', properties: { 'project-id': params.projectId } });
    }, []);

    if (isFetching && !project) {
        return <Loading />;
    }

    if (!project) {
        return <NotFound />;
    }

    return <ProjectEmbeddedComponent project={project} />;
};

export const loader = async ({ dispatch, params }) => {
    const promises = [
        dispatch(fetchProjectCard(params.projectId)),
        dispatch(fetchProjectTransactionAggregates(params.projectId)),
    ];
    await Promise.all(promises);
    return null;
};

export default withRouter(ProjectEmbeded);
